const textEncoder = new TextEncoder();

function normalizeAdditionalData(value?: Uint8Array | string): Uint8Array | undefined {
  if (!value) {
    return undefined;
  }
  if (typeof value === 'string') {
    return textEncoder.encode(value);
  }
  return value;
}

export async function encryptAesGcm(options: {
  key: Uint8Array;
  iv: Uint8Array;
  plaintext: Uint8Array;
  additionalData?: Uint8Array | string;
}): Promise<Uint8Array> {
  const { key, iv, plaintext, additionalData } = options;
  const cryptoKey = await crypto.subtle.importKey('raw', key, 'AES-GCM', false, [
    'encrypt',
  ]);
  const algorithm: AesGcmParams = { name: 'AES-GCM', iv };
  const aad = normalizeAdditionalData(additionalData);
  if (aad) {
    algorithm.additionalData = aad;
  }
  const ciphertext = await crypto.subtle.encrypt(algorithm, cryptoKey, plaintext);
  return new Uint8Array(ciphertext);
}

export async function decryptAesGcm(options: {
  key: Uint8Array;
  iv: Uint8Array;
  ciphertext: Uint8Array;
  additionalData?: Uint8Array | string;
}): Promise<Uint8Array> {
  const { key, iv, ciphertext, additionalData } = options;
  const cryptoKey = await crypto.subtle.importKey('raw', key, 'AES-GCM', false, [
    'decrypt',
  ]);
  const algorithm: AesGcmParams = { name: 'AES-GCM', iv };
  const aad = normalizeAdditionalData(additionalData);
  if (aad) {
    algorithm.additionalData = aad;
  }
  const plaintext = await crypto.subtle.decrypt(algorithm, cryptoKey, ciphertext);
  return new Uint8Array(plaintext);
}
